import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";
import commonFormMeta from '@Shared/components/form/commonFormMeta';

export interface IPrePersonalizationValidationDataTableRowFormMeta {
  
  client: FormInputMeta,
  PAN: FormInputMeta,
  cardName: FormInputMeta,
  sequence: FormInputMeta,
  startDate: FormInputMeta,
  endDate: FormInputMeta,
  operationType: FormInputMeta,
  ADIRTable: FormInputMeta,

  schema: any,
}

const PrePersonalizationValidationDataTableRowFormMeta = {} as IPrePersonalizationValidationDataTableRowFormMeta;

 
PrePersonalizationValidationDataTableRowFormMeta.PAN = commonFormMeta.PAN;

PrePersonalizationValidationDataTableRowFormMeta.client = {
  name: 'client',
  type: 'text',
  label: 'Client',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};

PrePersonalizationValidationDataTableRowFormMeta.cardName = {
  name: 'cardName',
  type: 'text',
  label: 'Nom sur la Carte',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};

PrePersonalizationValidationDataTableRowFormMeta.sequence = {
  name: 'sequence',
  type: 'text',
  label: 'Sequence',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};

PrePersonalizationValidationDataTableRowFormMeta.startDate = {
  name: 'startDate',
  type: 'date',
  label: 'Date Effective',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};

PrePersonalizationValidationDataTableRowFormMeta.endDate = {
  name: 'endDate',
  type: 'date',
  label: 'Exp.',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};

PrePersonalizationValidationDataTableRowFormMeta.operationType = {
  name: 'operationType',
  type: 'text',
  label: 'Type Operation',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
PrePersonalizationValidationDataTableRowFormMeta.ADIRTable = {
  name: 'ADIRTable',
  type: 'select',
  label: 'A.D.I.R.',
  options: [
    {
      label: 'A',
      value: 'a',
    },
    {
      label: 'D',
      value: 'd',
    },
    {
      label: 'I',
      value: 'i',
    },
    {
      label: 'R',
      value: 'r',
    },
  ],
  validation: yup.string().required(),
};


PrePersonalizationValidationDataTableRowFormMeta.schema = yup.object().shape(getValidationSchema(PrePersonalizationValidationDataTableRowFormMeta));

export default PrePersonalizationValidationDataTableRowFormMeta;